var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    {
      attrs: {
        placement: "bottom",
        width: "800",
        trigger: "click",
        "popper-class": "dg-dim-el-popover",
      },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _vm.visible
        ? _c("dg-table", {
            ref: "popoverDimTable",
            attrs: {
              apiCode: "distDimcode",
              "row-key": "DIMCODE",
              toolbarItems: _vm.tableModel.toolbarItems,
              border: true,
              tableItems: _vm.tableModel.tableItems,
            },
            on: { rowClick: _vm.rowClick, rowDblclick: _vm.rowClick },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-input",
        {
          directives: [
            {
              name: "cleaveEl",
              rawName: "v-cleaveEl",
              value: _vm.cleave || { notCleave: true },
              expression: "cleave || { notCleave: true }",
            },
          ],
          style: _vm.Dgstyle,
          attrs: {
            slot: "reference",
            type: "text",
            size: _vm.size || "mini",
            maxlength: _vm.maxlength,
            autosize: _vm.autosize,
            "prefix-icon": _vm.prefixIcon,
            "suffix-icon": _vm.suffixIcon,
            readonly: _vm.readonly,
            placeholder: _vm.placeholder || (_vm.disabled ? "" : "请输入"),
            disabled: _vm.disabled,
            clearable: true,
          },
          on: { clear: _vm.clearInput },
          slot: "reference",
          model: {
            value: _vm.innerValue,
            callback: function ($$v) {
              _vm.innerValue = $$v
            },
            expression: "innerValue",
          },
        },
        [
          _vm.prepend
            ? _c("template", { slot: "prepend" }, [
                _c("span", [_vm._v(_vm._s(_vm.prepend))]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.append
            ? _c("template", { slot: "append" }, [
                _c("span", [_vm._v(_vm._s(_vm.append))]),
              ])
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }